import React from "react";

import PageHero from "../../components/common/PageHero";
import PageSectionHeader from "../../components/common/PageSectionHeader";
import useScrollToTop from "../../hooks/useScollToTop";
import ScrollIndicator from "../Home/ScrollIndicator";

import EventFilters from "./components/EventFilters";
import EventList from "./components/EventList";
import Pagination from "./components/Pagination";
import EventDetailModal from "./components/EventDetailModal";

import { EVENTS_PAGE } from "./data/eventsUiData";
import { useEventsPage } from "./hooks/useEventsPage";

export default function EventsPage() {
  useScrollToTop();

  const {
    loading,
    error,
    items,
    paginatedItems,
    total,
    allTotal,
    totalPages,
    categories,
    filters,
    page,
    expandedEvent,
    updateFilter,
    resetFilters,
    toggleCategory,
    setLimit,
    setSort,
    setDir,
    goToPrevPage,
    goToNextPage,
    refresh,
    openEvent,
    closeEvent,
  } = useEventsPage();

  return (
    <>
      <PageHero
        title="Agenda"
        imageUrl={EVENTS_PAGE.heroImageUrl}
        crumbs={EVENTS_PAGE.crumbs}
      />

      <ScrollIndicator />

      <main className="mx-auto max-w-[1240px] px-4 pb-16 pt-6 sm:px-6 md:pt-8">
        <PageSectionHeader
          eyebrow={EVENTS_PAGE.eyebrow}
          title={EVENTS_PAGE.title}
          description={EVENTS_PAGE.description}
        >
          <div className="rounded-3xl border border-slate-200 bg-white/80 px-5 py-4 shadow-sm backdrop-blur dark:border-slate-800 dark:bg-slate-950/70">
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-500 dark:text-slate-400">
              Événements actifs
            </p>
            <p className="mt-1 text-3xl font-bold text-slate-950 dark:text-white">
              {loading ? "…" : allTotal}
            </p>
            <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
              publié{allTotal > 1 ? "s" : ""}
            </p>
          </div>
        </PageSectionHeader>

        <div className="mt-5">
          <EventFilters
            loading={loading}
            filters={filters}
            categories={categories}
            total={total}
            allTotal={allTotal}
            onChange={updateFilter}
            onCategoryClick={toggleCategory}
            onReset={resetFilters}
            onRefresh={refresh}
            onLimit={setLimit}
            onSort={setSort}
            onDir={setDir}
          />
        </div>

        {error && (
          <div className="mt-5 rounded-3xl border border-red-200 bg-red-50 px-5 py-4 text-sm font-semibold text-red-700 dark:border-red-900/60 dark:bg-red-950/30 dark:text-red-300">
            Une erreur est survenue pendant le chargement des événements.
          </div>
        )}

        <section className="mt-6">
          <EventList
            items={paginatedItems}
            loading={loading}
            onOpen={openEvent}
          />

          {!loading && items.length > 0 && (
            <Pagination
              page={page}
              totalPages={totalPages}
              total={total}
              limit={filters.limit}
              onPrev={goToPrevPage}
              onNext={goToNextPage}
              disabled={loading}
            />
          )}
        </section>
      </main>

      {expandedEvent && (
        <EventDetailModal event={expandedEvent} onClose={closeEvent} />
      )}
    </>
  );
}